import { render, staticRenderFns } from "./goodWorks.vue?vue&type=template&id=3bf233e8&scoped=true&"
import script from "./goodWorks.vue?vue&type=script&lang=js&"
export * from "./goodWorks.vue?vue&type=script&lang=js&"
import style0 from "./goodWorks.vue?vue&type=style&index=0&id=3bf233e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf233e8",
  null
  
)

export default component.exports